import type { PostHog } from 'posthog-js';

// types for Google Tag Manager
declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

/**
 * Does basic page view and leave tracking for posthog and gtm.
 */
export function trackPageView(
  posthog: PostHog,
  args: {
    previousPath: string | null;
    currentPath: string;
  },
) {
  const { previousPath, currentPath } = args;

  // Track page leave for previous page
  if (previousPath && previousPath !== currentPath) {
    posthog.capture('$pageleave', {
      path: previousPath,
    });

    // GTM page leave tracking
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'page_leave',
        page_path: previousPath,
      });
    }
  }

  // Track page view for current page
  posthog.capture('$pageview', {
    path: currentPath,
  });

  // GTM page view tracking
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'page_view',
      page_path: currentPath,
      page_title: document.title,
      page_location: window.location.href,
    });
  }
}
/**
 * Extracts all valid UTM params from a URL and returns
 * them as a record.
 */
export function extractUtmParams(url: string): Record<string, string> {
  const { searchParams } = new URL(url);

  return Object.fromEntries(
    Array.from(searchParams.entries()).filter(([key]) =>
      key.startsWith('utm_'),
    ),
  );
}
